import restTypes from '../util/rest/types';
import restStates from '../util/rest/states';
import restInitState from '../util/rest/initState';

const initialState = {};
const commentMessageRestTypes = restTypes('comment_message');

export default (state = { ...restInitState, ...initialState }, action = {}) => {
  switch (action.type) {
    case commentMessageRestTypes.fetchAllStart:
      return {
        ...state,
        ...restStates.fetchAllStart,
      };
    case commentMessageRestTypes.fetchAllFinished:
      return {
        ...state,
        ...restStates.fetchAllFinished,
        list: action.payload,
      };
    default: return state;
  }
};
